import {useTranslation} from "react-i18next";
import React from "react";
import {Box, CircularProgress, Dialog, DialogContent, Divider, Stack, Typography} from "@mui/material";
import {useQuery} from "react-query";
import {HobexTransactionLog} from "crqlar-react-common/dist/models/integrations/hobex/hobexTransactionLog.model";
import {InvoiceService} from "crqlar-react-common/dist/services/billing/invoice.service";
import Button from "@mui/material/Button";

interface Props {
    hobexLog?: HobexTransactionLog
    open: boolean,
    onClose: () => void,
    defaultRoomId?: string,
}

const HobexLogDetailsDialog = ({hobexLog, open, onClose, defaultRoomId}: Props) => {

    //region State

    const {t} = useTranslation()
    const [showInvoiceDetails, setShowInvoiceDetails] = React.useState(false)

    //endregion

    //region UI

    const paymentProviderRawString = hobexLog?.hobexProviderData
    const paymentProviderData: any | undefined = paymentProviderRawString ? JSON.parse(paymentProviderRawString) : undefined

    const invoiceDetailsQ = useQuery(['invoice', hobexLog?.invoiceRef], async () => {
        if (hobexLog?.invoiceRef) {
            return await InvoiceService.getInvoiceById(hobexLog.invoiceRef)
        }
    })

    return (
        <Dialog
            open={open}
            onClose={onClose}
            // fullWidth
            maxWidth={"lg"}
        >
            <DialogContent>
                <Stack
                    sx={{
                        gap: '16px',
                        width: '100%'
                    }}
                >
                    <Stack
                        gap={1}
                        width={'100%'}
                    >
                        <Typography>
                            {t('Merchant Transaction ID')}
                        </Typography>

                        <Typography fontWeight={'bold'}>
                            {hobexLog?.merchantTransactionId}
                        </Typography>
                    </Stack>

                    <Divider/>

                    <Stack
                        gap={1}
                        width={'100%'}
                    >
                        <Typography>
                            {t('Transaction type')}
                        </Typography>

                        <Typography fontWeight={'bold'}>
                            {t(`Transaction type ${hobexLog?.transactionType || 'UNKNOWN'}`)}
                        </Typography>
                    </Stack>

                    <Divider/>

                    <Stack
                        gap={1}
                        width={'100%'}
                    >
                        <Typography>
                            {t('Invoice ref')}
                        </Typography>

                        <Stack
                            direction={'row'}
                            alignItems={'center'}
                            gap={2}
                            width={'100%'}
                            justifyContent={'space-between'}
                        >
                            <Typography fontWeight={'bold'}>
                                {hobexLog?.invoiceRef}
                            </Typography>

                            {
                                !invoiceDetailsQ.isLoading && invoiceDetailsQ.data && (
                                    <Button
                                        variant={'outlined'}
                                        onClick={() => setShowInvoiceDetails(true)}
                                    >
                                        {t('View')}
                                    </Button>
                                )
                            }

                            {
                                invoiceDetailsQ.isLoading && (
                                    <CircularProgress/>
                                )
                            }

                        </Stack>

                    </Stack>

                    <Divider/>

                    <Stack
                        gap={1}
                        width={'100%'}
                    >
                        <Typography>
                            {t('Status')}
                        </Typography>

                        <Typography fontWeight={'bold'}>
                            {hobexLog?.success === true ? t('OK') : ''}
                            {hobexLog?.success === false ? t('Failed') : ''}
                            {hobexLog?.success !== true && hobexLog?.success !== false ? '-' : ''}

                        </Typography>
                    </Stack>

                    <Divider/>

                    <Stack
                        gap={1}
                        width={'100%'}
                    >
                        <Typography>
                            {t('Amount')}
                        </Typography>

                        {
                            hobexLog?.amountCents !== undefined ?
                                <Typography fontWeight={'bold'}>
                                    {[(hobexLog?.amountCents ?? 0) / 100, hobexLog?.currency].filter(Boolean).join(' ')}
                                </Typography>
                                :
                                <Typography fontWeight={'bold'}>
                                    -
                                </Typography>
                        }


                    </Stack>

                    <Divider/>

                    <Stack
                        gap={1}
                        width={'100%'}
                    >
                        <Typography>
                            {t('Hobex raw response')}
                        </Typography>
                        <Box
                            display={'flex'}
                            boxSizing={'border-box'}
                            flexDirection={'column'}
                            sx={{
                                overflowY: 'auto',
                                whiteSpace: 'pre-wrap',
                                fontSize: 12
                            }}
                            // maxHeight={dimensions.height - 200}
                        >
                            {JSON.stringify(paymentProviderData, null, 2)}
                        </Box>
                    </Stack>


                </Stack>

            </DialogContent>

            {/*<InvoiceDetailsDialog*/}
            {/*    payment={invoiceDetailsQ.data}*/}
            {/*    open={showInvoiceDetails}*/}
            {/*    onClose={() => setShowInvoiceDetails(false)}*/}
            {/*    hideLogsCta*/}
            {/*/>*/}

        </Dialog>
    )

//endregion UI
}

export default HobexLogDetailsDialog
